import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {CoercionUtils} from '@mintdata/mint-kit/impl/coercionUtils/CoercionUtils';
import _flatMap from 'lodash/flatMap';

export class TextUtil
{
    public static escapeLiteral(s:string):string
    {
        //taken from here: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Using_parentheses
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    public static trimEnds(s:string, toTrim:string)
    {
        if( !s )
            return s;

        const start = s.startsWith(toTrim) ? 1 : 0;
        const end = s.endsWith(toTrim) ? s.length - 1 : s.length;
        return s.substring(start, end);

    }

    public static stripQuotesInStringLiteral(s:string, quoteSymbol:string = '\'')
    {
        if( s && s.length > 1 && s.startsWith(quoteSymbol) && s.endsWith(quoteSymbol) )
            s = s.substring(1, s.length - 1).replace('\\\'', '\'');

        return s;
    }

    // usefull to convert some random text to representative id
    public static convertToSimpleId(s:string):string
    {
        if( s == null )
            return null;

        let id = s.toLowerCase().replace(/[^a-z0-9_-]/g, '');

        // add "id" at the start if doesn't start with a letter or underscore
        if( id.length == 0 || !id[0].match(/[a-z_]/) )
            id = 'id' + id;

        return id;
    }

    public static escapeRegExp(s:string):string
    {
        // from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    // this will coerce primitives to strings, and for IFrame - coerce all it's cells to strings
    public static collectStringsFromIValues(args:IValue[]):Array<string> | AError
    {
        const result = [];
        for( const arg of args )
        {
            const values = Type.isInstanceOf(arg, Type.Frame)
                ? _flatMap((arg as IFrame).getRecords().map(r => r.getCells()))
                : [arg];

            for( const value of values )
            {
                const coerced = CoercionUtils.coerce(value, Type.String, null);
                if( Type.isInstanceOf(coerced, Type.Error) )
                    return new AError('#CANT_COERCE_VALUE_TO_STRING');

                result.push((coerced as AString).value);
            }
        }

        return result;
    }

    // TODO: this utility doesn't really belongs to `Text`Util class...
    // this will coerce primitives to integers, and for IFrame - coerce all it's cells to integers
    public static collectIntegersFromIValues(args:IValue[]):Array<number> | AError
    {
        const result = [];
        for( const arg of args )
        {
            const values = Type.isInstanceOf(arg, Type.Frame)
                ? _flatMap((arg as IFrame).getRecords().map(r => r.getCells()))
                : [arg];

            for( const value of values )
            {
                const coerced = CoercionUtils.coerce(value, Type.Integer, null);
                if( Type.isInstanceOf(coerced, Type.Error) )
                    return new AError('#CANT_COERCE_VALUE_TO_INTEGER');

                result.push((coerced as AInteger).value);
            }
        }

        return result;
    }
}
